import type { GetLineOfBusinessResponse } from '@/types/LineOfBusiness.ts'
import { apiGet } from './ApiClient'

export async function getLinesOfBusiness(): Promise<GetLineOfBusinessResponse> {
  return await apiGet<GetLineOfBusinessResponse>('/line-of-business')
}
